import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'
import { xor } from 'lodash'

import { AddNewProgramFormModel } from '../../AddNewProgram.types'
import { FieldSection } from '../../formSection/fieldSection/FieldSection'

import { Alert, Checkbox } from '@percent/lemonade'
import {
  MutuallyExclusiveOrganisationTypes,
  NonConflictingOrganisationTypes,
  OrganisationTypes
} from '@percent/domain/verifications'

export function AllowedOrganisationTypes() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [allowedOrganisationTypes] = useWatch({
    control,
    name: ['allowedOrganisationTypes']
  })

  const onAllowedOrganisationChange = (orgType: OrganisationTypes) =>
    setValue('allowedOrganisationTypes', xor(allowedOrganisationTypes, [orgType]), {
      shouldValidate: true,
      shouldDirty: true
    })

  return (
    <FieldSection title={t('form.allowedOrganizationTypes')}>
      {!allowedOrganisationTypes?.length && <Alert variant="warning" title={t('errorMessage.selectAtLeastOne')} />}
      <Checkbox
        variant="default"
        active={allowedOrganisationTypes?.includes(MutuallyExclusiveOrganisationTypes.Nonprofit)}
        name="nonProfit"
        label={t('form.nonprofit')}
        onChange={() => onAllowedOrganisationChange(MutuallyExclusiveOrganisationTypes.Nonprofit)}
      />
      <Checkbox
        variant="default"
        active={allowedOrganisationTypes?.includes(NonConflictingOrganisationTypes.Education)}
        name="education"
        label={t('form.education')}
        onChange={() => onAllowedOrganisationChange(NonConflictingOrganisationTypes.Education)}
      />
      <Checkbox
        variant="default"
        active={allowedOrganisationTypes?.includes(MutuallyExclusiveOrganisationTypes.SocialImpact)}
        name="socialImpact"
        label={t('form.socialImpact')}
        onChange={() => onAllowedOrganisationChange(MutuallyExclusiveOrganisationTypes.SocialImpact)}
      />
    </FieldSection>
  )
}
